import React, { FunctionComponent } from 'react';
import { faUser } from '@fortawesome/free-solid-svg-icons';
import { BrassIcon, BrassIconProps } from '..';

const BrassIconUser: FunctionComponent<BrassIconProps> = (props: BrassIconProps) => (
  <BrassIcon {...props} icon={faUser} />
);

export { BrassIconUser };
